import { useEffect, useState } from "react";
import { registerSW } from "virtual:pwa-register";

/**
 * Service-worker lifecycle (SPEC §17.8): a new SW waits; the UI shows "Update ready — reload".
 * `applyUpdate` is the only way to activate it. Callers must not call it while a position is
 * open or a strategy instance is starting (that guard lands with trading state in Phase 2).
 */
export function useServiceWorker(): { updateReady: boolean; applyUpdate: () => void } {
  const [updateReady, setUpdateReady] = useState(false);
  const [update, setUpdate] = useState<((reload?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        setUpdateReady(true);
      },
    });
    setUpdate(() => updateSW);
  }, []);

  return {
    updateReady,
    applyUpdate: () => {
      void update?.(true);
    },
  };
}
